var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcStampBill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 76C55.8823 76 72 59.8823 72 40C72 20.1178 55.8823 4 36 4C16.1178 4 0 20.1178 0 40C0 59.8823 16.1178 76 36 76Z",
    fill: "#0E5CF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 71C59.33 71 75 55.33 75 36C75 16.67 59.33 1 40 1C20.67 1 5 16.67 5 36C5 55.33 20.67 71 40 71Z",
    fill: "white",
    stroke: "#00193C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 17H29V19H30V17ZM52.5 53L52.0294 53.8824C52.3067 54.0302 52.6374 54.0392 52.9222 53.9065C53.2071 53.7738 53.413 53.5149 53.4782 53.2075L52.5 53ZM30 53H29C29 53.3513 29.1843 53.6768 29.4855 53.8575C29.7867 54.0382 30.1607 54.0477 30.4706 53.8824L30 53ZM41.25 55L40.5856 55.7474C40.9645 56.0842 41.5355 56.0842 41.9144 55.7474L41.25 55ZM46.875 50L47.3456 49.1176L46.7311 48.7899L46.2106 49.2526L46.875 50ZM35.625 50L36.2894 49.2526L35.7689 48.7899L35.1544 49.1176L35.625 50ZM53.6323 23.0615L52.6369 23.1577L53.6323 23.0615ZM30 19H41.5V17H30V19ZM41.5 19H47.8946V17H41.5V19ZM31 53C31 51.936 31.2232 49.2975 31.4577 45.8055C31.6894 42.3571 31.9249 38.1576 31.9349 34.0895C31.945 30.038 31.7324 26.047 31.042 23.043C30.6982 21.5472 30.2175 20.2099 29.5236 19.2247C28.8105 18.2122 27.8112 17.5 26.5 17.5V19.5C26.9787 19.5 27.4313 19.7273 27.8885 20.3764C28.3649 21.0527 28.7729 22.0988 29.0928 23.491C29.7299 26.2628 29.9449 30.0653 29.9349 34.0845C29.925 38.0871 29.693 42.2354 29.4622 45.6715C29.2343 49.064 29 51.8467 29 53H31ZM41.9144 55.7474L47.5394 50.7474L46.2106 49.2526L40.5856 54.2526L41.9144 55.7474ZM46.4044 50.8824L52.0294 53.8824L52.9706 52.1176L47.3456 49.1176L46.4044 50.8824ZM30.4706 53.8824L36.0956 50.8824L35.1544 49.1176L29.5294 52.1176L30.4706 53.8824ZM34.9606 50.7474L40.5856 55.7474L41.9144 54.2526L36.2894 49.2526L34.9606 50.7474ZM52.6369 23.1577C53.3665 30.7124 53.7001 42.5234 51.5218 52.7925L53.4782 53.2075C55.7173 42.652 55.3659 30.6101 54.6276 22.9654L52.6369 23.1577ZM47.8946 19C50.3592 19 52.4069 20.7766 52.6369 23.1577L54.6276 22.9654C54.2918 19.4877 51.316 17 47.8946 17V19Z",
    fill: "#0E5CF4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 18H29C25.6863 18 23 20.6863 23 24V31L24.75 29.087L26.5 31L28.25 29.087L30 31L30.5 30.0435",
    stroke: "#0E5CF4",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35 31H41",
    stroke: "#0E5CF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35 37H49",
    stroke: "#0E5CF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35 43H49",
    stroke: "#0E5CF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35 25H41",
    stroke: "#0E5CF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47 24.9C45.8954 24.9 45 25.7059 45 26.7C45 27.6941 45.6667 28.5 47 28.5C48.3333 28.5 49 29.3059 49 30.3C49 31.2941 48.1046 32.1 47 32.1M47 24.9C47.7403 24.9 48.3866 25.262 48.7324 25.8M47 24.9V24M47 32.1L47 33M47 32.1C46.2597 32.1 45.6134 31.738 45.2676 31.2",
    stroke: "#0E5CF4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStampBill);
export default __webpack_public_path__ + "static/media/ic-stamp-bill.46bd0e80237c0a71790f988099b82c85.svg";
export { ForwardRef as ReactComponent };